// Dispatcher
/**
 * Base class for all scenario modules that interact with other modules and stores
 */ export class CoreScenarioModule {
    /**
     * Name of the module for telemetry
     */ get name() {
        return this.constructor.name;
    }
    /**
     * Initializes an instance of an scenario module
     * @param dispatcher The dispatcher the SPA uses to dispatch actions
     * @param loggers Loggers for telemetry
     * @param stores Loader for the stores
     * @param moduleLoader Loader for logic modules
     * @param configProvider Delegate to retrieve the app configuration
     */ constructor(dispatcher, loggers, stores, moduleLoader, configProvider){
        this.dispatcher = dispatcher;
        this.loggers = loggers;
        this.stores = stores;
        this.moduleLoader = moduleLoader;
        this.configProvider = configProvider;
    }
}
